import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter, Route } from 'react-router-dom';

const mount = document.getElementById("image-search");

// Filter vocabulary is inlined on the page by ImageSearchController — read it
// here rather than inside App so the component takes it as an ordinary prop.
let facets = { categories: [], permits: [], cities: [], counties: [], without_coordinates: 0 };

try {
    facets = Object.assign(facets, JSON.parse((mount && mount.dataset.facets) || "{}"));
} catch (e) {
    // A malformed attribute must not take the whole search down; the filters
    // just render empty.
    console.error("Could not parse image-search facets", e);
}

ReactDOM.render(
    <BrowserRouter basename="/ai-search">
        <Route path="/:token?" render={(routeProps) => <App {...routeProps} facets={facets} />} />
    </BrowserRouter>,
    mount
);
